.bundlesInProgress:has(ul > li) > p {
  display: block;
}

.bundlesInProgress ul:empty {
  display: none;
}

.bundlesInProgressTitle {
  display: none;
}
